
import { throttle } from 'throttle-debounce';

const headerSlide = () => {
  let prevPosition = 0
  const header = document.querySelector('#shopify-section-header')

  window.addEventListener(
    'scroll',
    throttle(33, false, () => {
      if(window.scrollY > prevPosition && window.scrollY > 120) {
        document.body.classList.add('scrolling-down')
        // fixes wierd side scroll when header off screen
        header.style.overflowX = 'hidden'
      } else {
        document.body.classList.remove('scrolling-down')

        setTimeout(() => {
          header.style.overflowX = 'visible'
          // same timing as transition in header.scss plus throttle 
        }, 533)
      }
      prevPosition = window.scrollY
    })
  );
}

export default headerSlide